<template>
  <el-drawer :visible.sync="drawer" :with-header="false" size="860px" @close="close">
    <div class="join-inquiry-list-drawer">
      <div>
        <i class="el-icon-close" style="font-size:22px" @click="close"></i>
      </div>
      <div class="join-inquier-list-product">
        <div class="item-box-add">
          <el-row>
            <el-col :span="18">
              <span class="title-font-style">采购日报表</span>
            </el-col>
            <el-col :span="6" style="text-align:right">
              <el-button @click="exportOut">导出</el-button>
            </el-col>
          </el-row>
          <div :style="{height:tableHeight+'px'}">
            <el-table
              :summary-method="getSummaries"
              show-summary
              border
              ref="tableRef"
              tooltip-effect="dark"
              :data="list"
              :max-height="tableHeight"
              :header-cell-style="tableHeader"
              v-loading="loadingTable"
              element-loading-text="拼命加载中请稍后..."
              element-loading-spinner="el-icon-loading"
            >
              <el-table-column label="日期" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div class="line-limit-length">{{scope.row.signDate|| '--'}}</div>
                </template>
              </el-table-column>
              <el-table-column label="负责人" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div class="line-limit-length">{{scope.row.staffCnName|| '--'}}</div>
                </template>
              </el-table-column>
              <el-table-column label="所属部门" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div class="line-limit-length">{{scope.row.orgName|| '--'}}</div>
                </template>
              </el-table-column>
              <el-table-column label="合同编号" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div class="line-limit-length">{{scope.row.pcbNumber|| '--'}}</div>
                </template>
              </el-table-column>
              <el-table-column label="供应商合同编号" width="120" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div class="line-limit-length">{{scope.row.supplierContractNumber || '--'}}</div>
                </template>
              </el-table-column>
              <el-table-column label="供应商名称" width="110" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div class="line-limit-length">{{scope.row.suName || '--'}}</div>
                </template>
              </el-table-column>
              <el-table-column label="合同金额" width="100">
                <template slot-scope="scope">
                  <div>{{scope.row.contractMoney | priceFilterNum}}</div>
                </template>
              </el-table-column>
              <el-table-column label="付款类型">
                <template slot-scope="scope">
                  <div>{{scope.row.payType || '--'}}</div>
                </template>
              </el-table-column>
              <el-table-column label="已付账款">
                <template slot-scope="scope">
                  <div>{{scope.row.accountsPaid | priceFilterNum}}</div>
                </template>
              </el-table-column>
              <el-table-column label="应付账款" width="100">
                <template slot-scope="scope">
                  <div>{{scope.row.contractMoney | priceFilterNum}}</div>
                </template>
              </el-table-column>
              <el-table-column label="已到期应付账款" width="140">
                <template slot-scope="scope">
                  <div>{{scope.row.accountsDue | priceFilterNum}}</div>
                </template>
              </el-table-column>
              <el-table-column label="未到期应付账款" width="140">
                <template slot-scope="scope">
                  <div>{{scope.row.accountsOutstanding | priceFilterNum}}</div>
                </template>
              </el-table-column>
              <el-table-column label="已收票金额" width="120">
                <template slot-scope="scope">
                  <div>{{scope.row.receivedAmount | priceFilterNum}}</div>
                </template>
              </el-table-column>
              <el-table-column label="未收票金额" width="120">
                <template slot-scope="scope">
                  <div>{{scope.row.noReceivedAmount |priceFilterNum}}</div>
                </template>
              </el-table-column>
              <el-table-column label="合同状态">
                <template slot-scope="scope">
                  <div>{{scope.row.contractState=== 1 ?'待审核': scope.row.contractState=== 2?'审核中':scope.row.contractState=== 3?'履行中' :scope.row.contractState=== 4?'已履行':scope.row.contractState=== 5?'待签署':'--'}}</div>
                </template>
              </el-table-column>
              <el-table-column label="详情">
                <template slot-scope="scope">
                  <el-button type="text" @click="checkSlider(scope.row)">查看</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagination" style="padding-top:20px;">
            <pagination
              :total="total"
              :currentPage="currentPage"
              :pageSize="pageSize"
              @handleCurrentChange="handleCurrentChange"
              @handleSizeChange="handleSizeChange"
            ></pagination>
          </div>
        </div>
            <!-- 查看详情 -->
    <el-slider ref="dailyPurchaseReportSliderRefs"></el-slider>
      </div>
    </div>
  </el-drawer>
</template>
<script>
import pagination from '@/components/pagination'
import { queryReportPurchaseDay, exportReportPurchaseDays } from '@/api/data/data'
import { isSuccess, downLoadFileBlob } from '@/util/tool'
import dailyPurchaseReportSlider from '../slider/dailyPurchaseReportSlider'

export default {
  components: {
    pagination,
    'el-slider': dailyPurchaseReportSlider
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 30,
      total: 0,
      drawer: false,
      list: [],
      queryParams: '',
      tableHeight: window.innerHeight - 380,
      loadingTable: false,
      searchList: []
    }
  },
  methods: {
    getSummaries(param) {
      // 合计
      const sums = []
      param.columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总计'
        } else if (index === 6) {
          const total = param.data.reduce((tot, prov) => {
            return tot + +prov.contractMoney
          }, 0)
          sums[index] = total.toFixed(2)
        } else if (index === 8) {
          const total = param.data.reduce((tot, prov) => {
            return tot + +prov.accountsPaid
          }, 0)
          sums[index] = total.toFixed(2)
        } else if (index === 9) {
          const total = param.data.reduce((tot, prov) => {
            return tot + +prov.contractMoney
          }, 0)
          sums[index] = total.toFixed(2)
        } else if (index === 10) {
          const total = param.data.reduce((tot, prov) => {
            return tot + +prov.accountsDue
          }, 0)
          sums[index] = total.toFixed(2)
        } else if (index === 11) {
          const total = param.data.reduce((tot, prov) => {
            return tot + +prov.accountsOutstanding
          }, 0)
          sums[index] = total.toFixed(2)
        } else if (index === 12) {
          const total = param.data.reduce((tot, prov) => {
            return tot + +prov.receivedAmount
          }, 0)
          sums[index] = total.toFixed(2)
        } else if (index === 13) {
          const total = param.data.reduce((tot, prov) => {
            return tot + +prov.noReceivedAmount
          }, 0)
          sums[index] = total.toFixed(2)
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    // 报缺侧边栏初始化
    onInitialize(row, list) {
      this.searchList = list
      this.searchList.push({
        value: row.purchaseMonth,
        column: 'purchaseMonth'
      })
      this.queryParams = row
      this.drawer = true
      this.getList()
    },
    getList() {
      this.loadingTable = true
      const params = {
        criteriaVoList: this.searchList ? this.searchList : [],
        queryPageName: ''
      }
      queryReportPurchaseDay(this.currentPage, this.pageSize, 1, params).then(
        res => {
          if (isSuccess(res)) {
            this.list = res.data.obj.records
            this.total = res.data.obj.total
            this.loadingTable = false
          }
        }
      )
    },

    // 查看详情
    checkSlider(row) {
      this.$refs.dailyPurchaseReportSliderRefs.onInitialize(row)
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 关闭
    close() {
      this.drawer = false
      this.$emit('closeList')
    },

    exportOut() {
      const params = {
        criteriaVoList: this.searchList,
        queryPageName: ''
      }

      exportReportPurchaseDays(1, params)
        .then(res => {
          downLoadFileBlob(this, res)
        })
        .catch(err => {
          console.log(err)
        })
    },
    handleSizeChange(val) {
      this.currentPage = 1
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    }
  }
}
</script>
<style  lang="scss" scoped>
.boxHeight {
  height: 200px;
}
h5,
h4 {
  text-align: center !important;
}
h5 {
  margin: 0px !important;
  font-size: 14px;
}
.join-inquiry-list-drawer {
  padding: 20px;
  font-size: 14px !important;
  .join-inquier-list-crumbs {
    padding-left: 20px;
    font-size: 14px;
    span:first-child {
      padding-right: 10px;
    }
  }
  .join-inquier-list-product {
    padding: 30px 0 0 0px;
    .item-box-add {
      margin: 0 0 30px 0;
      .title-font-style {
        margin-bottom: 20px;
        font-weight: bold;
        font-size: 16px;
      }
      .serial_list {
        border: 1px solid #ebeef6;
        height: 500px;
        margin-top: 15px;
        width: 100%;
        display: flex;
        align-content: flex-start;
        justify-content: flex-start;
        flex-wrap: wrap;
        .serial_list_item {
          border-right: 1px solid #ebeef6;
          border-bottom: 1px solid #ebeef6;
          width: 16.5%;
          height: 40px;
          line-height: 40px;
          text-align: center;
          &:nth-child(6n) {
            border-right: none;
          }
        }
      }
    }
  }
  .dialog-footer {
    width: 180px;
    margin: 30px auto;
    float: right;
  }
}
</style>
